import { render, staticRenderFns } from "./SelectPaymentProvider.vue?vue&type=template&id=052bc3b4&"
import script from "./SelectPaymentProvider.vue?vue&type=script&lang=ts&"
export * from "./SelectPaymentProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports